import React from "react";
import styles from "./ErrorLabel.module.css";

function ErrorLabel({
  LabelName,
  labelFor,
  hasErrors,
  errorMessages,
  className,
}) {
  return (
    <div className={styles.errorLabelContainer}>
      <label className={`${className} ${hasErrors ? styles.errorLabel : ""}`} htmlFor={labelFor}>
        {LabelName}
      </label>
      {hasErrors && (
        <ErrorBody errorMessages={errorMessages} LabelName={LabelName} />
      )}
    </div>
  );
}

export default ErrorLabel;
export function ErrorBody({ errorMessages, LabelName }) {
    return <div className={styles.errorMessage}>
        <ul>
            {Array.isArray(errorMessages) ? (
                errorMessages.map((msg, index) => <li key={index}>{msg}</li>)
            ) : (
                <li>{`Invalid ${LabelName}`}</li>
            )}
        </ul>
    </div>;
}


